import { getApiUrl, getUsersIdAvatarPath } from "Infrastructure/Api/Api";
import { userAvatarVersionAtom } from "Settings/User/Atom/userAvatarVersionAtom";
import ProfileImg from "Shared/Assets/Images/Profiles/user-1.jpg";
import { useAtom } from "jotai";
import { useMemo } from "react";

export const useAvatarFilePath = (
	userId?: number,
	avatarFileName?: string | null,
) => {
	const [userAvatarVersion] = useAtom(userAvatarVersionAtom);

	const avatarFilePath = useMemo(() => {
		if (userId && avatarFileName) {
			return `${getApiUrl()}${getUsersIdAvatarPath(userId)}?v=${userAvatarVersion}`;
		}
		return ProfileImg;
	}, [userId, avatarFileName, userAvatarVersion]);

	return avatarFilePath;
};
